import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import Tooltip from "@mui/material/Tooltip"
import { ReactNode } from "react"

export type CompactSelectOptionT = {
    value: string
    label: string
    /** shown but not choosable — "Mixed" when the selection holds different values */
    disabled?: boolean
}

interface Props {
    /** the field name handed to `handleOnChange` as `e.target.name` */
    name: string
    value: string | undefined
    options: CompactSelectOptionT[]
    /** what the field is, shown on hover — the caption above the row names the group */
    tooltip: string
    handleOnChange: (e: any) => void
    /** the field's name shown inside it, above the value, like PrefixedInput's label */
    label?: string
    /** short text in front of the value, like PrefixedInput's prefix */
    prefix?: ReactNode
}

/** A select that fills its column — the partner of PrefixedInput. */
const CompactSelect = ({ name, value, options, tooltip, handleOnChange, label, prefix }: Props) => (
    <Tooltip title={tooltip} placement="top" enterDelay={600}>
        <TextField
            select
            name={name}
            value={value ?? ""}
            onChange={handleOnChange}
            label={label}
            hiddenLabel={!label}
            fullWidth
            sx={{ m: 0 }}
            SelectProps={{ native: true }}
            InputLabelProps={label ? { shrink: true } : undefined}
            inputProps={{ "aria-label": tooltip }}
            InputProps={{
                disableUnderline: true,
                startAdornment: prefix !== undefined && (
                    <InputAdornment
                        position="start"
                        sx={{ color: "text.secondary", mr: 0.5, flexShrink: 0 }}
                    >
                        {prefix}
                    </InputAdornment>
                ),
            }}
        >
            {options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label}
                </option>
            ))}
        </TextField>
    </Tooltip>
)

export default CompactSelect
